import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { DsrFooterComponent, DsrHeaderComponent, DsrModeSwitcherComponent, DsrNavbarComponent } from '@desyre/angular-material';
import { DsrIconsModule } from '@desyre/icons-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CoreModule } from './core/core.module';
import { HomeModule } from './features/home/home.module';
import { FooterComponent } from './core/components/footer/footer.component';
import { HeaderComponent } from './core/components/header/header.component';
import { FaqModule } from './features/faq/faq.module';
import { RegistrationModule } from './features/registration/registration.module';
import { RegularyDataModule } from './features/regulary-data/regulary-data.module';
import { ContactModule } from './features/contact/contact.module';
import { EditProfileModule } from './features/edit-profile/edit-profile.module';

// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SubscriptionsModule } from './features/subscriptions/subscriptions.module';
import { InvoicesModule } from './features/invoices/invoices.module';
import { AdministrationModule } from './features/administration/administration.module';

import { ChatbotModule } from './features/chatbot/chatbot.module';
import { ACCESS_TOKEN_KEY } from './types/constants';
import { PaymentModule } from './features/payment/payment.module';
import { PaymentResponseModule } from './features/paymentResponse/paymentResponse.module';
import { authGuard } from './core/guards/auth.guard';
import { accessGuard } from './core/guards/access.guard';
import { RegistrationService } from './features/registration/registration.service';
import { registrationInfo } from './types/registrationInfo';
import { registrationListInfo } from './types/registrationListInfo';
import { EditProfileService } from './features/edit-profile/edit-profile.service';
import { CacheService } from './shared/services/cache/cache.service';
import { OfferDetailsService } from './features/offers/offers-new-dialogys/offer-details.service';
import { gigyaInfo } from './types/gigyaInfo';
import { SubscriptionService } from './features/subscriptions/subscriptions.service';
import { InvoiceInfo } from './types/InvoiceInfo';
import { TokenService } from './shared/services/token/token.service';
import { TokenInterceptor } from './shared/interceptor/token.interceptor';
import { paymentInfo } from './types/paymentInfo';
import { PaymentService } from './features/payment/payment.service';
import { FormatMobileNumberPipe } from './shared/pipes/formatMobile-number.pipe';
import { FormatPricePipe } from './shared/pipes/formatPrice.pipe';
import { ReprogrammingService } from './features/offers/offers-euro/reprogramming.service';
import { AdministrationService } from './features/administration/administration.service';
import { InvoiceService } from './features/invoices/invoices.service';
import { NgRenaultFeedbackModule } from 'ng-renault-feedback';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DsrIconsModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    CoreModule,
    HomeModule,
    FaqModule,
    RegistrationModule,
    RegularyDataModule,
    EditProfileModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SubscriptionsModule,
    InvoicesModule,
    AdministrationModule,
    ChatbotModule,
    PaymentModule,
    PaymentResponseModule,
    NgRenaultFeedbackModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()), 
    RegistrationService, registrationInfo, registrationListInfo, EditProfileService, CacheService, 
    OfferDetailsService, gigyaInfo, SubscriptionService, InvoiceInfo, TokenService, InvoiceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }, 
    PaymentService, paymentInfo, HeaderComponent, FormatMobileNumberPipe, FormatPricePipe, AdministrationService,
    ReprogrammingService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  const version = '1.3.3';
  return new TranslateHttpLoader(http, 'assets/i18n/', `.json?v=${version}`);
}
